import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// import components
import Nav from "../base_layout/Header/Nav";
import AppFooter from "../base_layout/AppFooter";
import LandingPage from "../pages/LandingPage";
import AboutPage from "../pages/AboutPage";
import ProjectPage from "../pages/ProjectPage";
import ProcessPage from "../pages/ProcessPage";
import ContactPage from "../pages/ContactPage";
import NoMatch from "../NoMatch/NoMatch";
import WebSystems from "../pages/category/WebSystems";
import Branding from "../pages/category/Branding";
import ScrollToTop from "../ScrollToTop";
import Photography from "../pages/category/Photography";
import Illustrations from "../pages/WorkDetails";
import Stickers from "../pages/category/Stickers";
import LayoutDesign from "../pages/category/LayoutDesign";
import WorkDetails from "../pages/WorkDetails";

class AppLayout extends Component {
  state = {
      scrolled: false
  }

componentDidMount () {
    window.addEventListener('scroll', () => {
        const isTop = window.scrollY < 100;
        if (!isTop ) {
            this.setState({ scrolled: true })
        } else {
            this.setState({ scrolled: false })
        }
    })
}

// componentWillUnmount () {
//     window.removeEventListener('scroll')
// }

handleScrollDown() {
    if (window.pageYOffset === 0 && window.screen.width <= 500) {
        // console.log('small', window.screen.width)
        window.scrollTo(0,600)
    } else {
        // console.log('big', window.screen.width)
        window.scrollTo(0,800)
    }
}
  render() {
    const { scrolled } = this.state
    return (
      <Router>
        <ScrollToTop>
          <Nav scrolled={scrolled} />
          <Switch>
            <Route exact path="/" component={LandingPage} />
            <Route path="/about" component={AboutPage} />
            <Route exact path="/work" component={ProjectPage} />
            <Route path="/work/:id" component={WorkDetails} />
            <Route path="/contact" component={ContactPage} />
            <Route path="/process" component={ProcessPage} />
            <Route exact path="/branding" component={Branding} />
            <Route path="/branding/:id" component={Branding} />
            <Route exact path="/websystems" component={WebSystems} />
            <Route path="/websystems/:id" component={WebSystems} />
            <Route exact path="/photography" component={Photography} />
            <Route path="/photography/:id" component={Photography} />
            <Route exact path="/illustrations" component={Illustrations} />
            <Route path="/illustrations/:id" component={Illustrations} />
            <Route exact path="/stickers" component={Stickers} />
            <Route path="/stickers/:id" component={Stickers} />
            <Route exact path="/layoutdesign" component={LayoutDesign} />
            <Route path="/layoutdesign/:id" component={LayoutDesign} />
            <Route component={NoMatch} />
          </Switch>
          <AppFooter />
        </ScrollToTop>
      </Router>
    );
  }
}

export default AppLayout;



// WEBPACK FOOTER //
// ./src/components/base_layout/AppLayout.js